import { Ref } from '@vue/composition-api'
import { ref } from '@nuxtjs/composition-api'

export function useMultiLanguagesForm(
  languages: Record<string, any>,
  validate?: ((lang: string, text: string) => void) | null
) {
  const createMultilingualField = (langItems: Record<string, any>) => {
    const o: Record<string, any> = {}
    Object.keys(langItems).forEach(lang => {
      o[lang] = null
    })
    return ref<Record<string, any>>({ ...o })
  }
  const errors = createMultilingualField(languages)
  const values = createMultilingualField(languages)
  const onError = (e: Ref<any>) => {
    if (!e.value) {
      return
    }
    if (typeof e.value === 'string') {
      errors.value.el = e.value
      return
    }
    // TODO: fix this
    errors.value.en = e.value.en
    errors.value.el = e.value.el
  }

  const onValue = (v: Ref<any>) => {
    if (!v.value) {
      return
    }
    Object.keys(languages).forEach(lang => {
      if (lang in v.value) {
        values.value[lang] = v.value[lang]

        validate && validate(lang, v.value[lang])
      }
    })
  }

  return { values, errors, onError, onValue, createMultilingualField }
}
